// ForbiddenPage.js
import React from 'react';
import { Link } from 'react-router-dom';

const ForbiddenPage = () => {
    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5',
        textAlign: 'center',
    };

    const headingStyle = {
        fontSize: '48px',
        color: '#333',
    };

    const textStyle = {
        fontSize: '20px',
        color: '#666',
    };

    const buttonStyle = {
        padding: '10px 20px',
        fontSize: '16px',
        color: '#2A6E62',
        backgroundColor: '#E6F6F4',
        border: 'none',
        borderRadius: '4px',
        textDecoration: 'none',
        cursor: 'pointer',
    };


    return (
        <div style={containerStyle}>
            <h1 style={headingStyle}>403 Forbidden</h1>
            <p style={textStyle}>
                You don't have permission to access this page.
            </p>
            <Link to="/" style={buttonStyle}>
                Go to Home
            </Link>
        </div>
    );
};

export default ForbiddenPage;
